import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { CacheService } from '../../../front/src/app/core/services/cache.service';
import { CONTACT_EMAIL } from '../../models/constants';
import { IntegrationsData, OrganizationExtended, User } from '../../models/main';
import { ApiService } from '../../services/api.service';
import { CustomValidators } from '../../shared/custom-validators';


@Component({
  selector: 'app-applications-form[organization]',
  templateUrl: './applications-form.component.html',
  styleUrls: ['./applications-form.component.scss'],
})
export class ApplicationsFormComponent implements OnInit {

  @Input() organization!: OrganizationExtended;
  CONTACT_EMAIL = CONTACT_EMAIL;
  form!: FormGroup;
  icons = {
    'iaDataExtraction': 'spark-line',
    'draftDocuments': 'details',
    'cargox': 'cargox',
    'edocs': 'edoc',
    'powerBi': 'growth',
    'lune': 'moon',
    'gesinflot': 'transport-road',
    'adam': 'daas',
    'developerMode': 'settings',
    'transportControl': 'file-text',
  };

  users: User[] = [];

  constructor(private fb: FormBuilder, private api: ApiService, private ar: ActivatedRoute, private cache: CacheService) {
  }

  ngOnInit(): void {
    this.ar.params.subscribe((params) => {
      if (params.id) {
        // si hay params.id estoy en BO, cojo el get organization
        this.api.getOrganization(params.id).subscribe(res => {
          this.organization = res;
          this.api.getMembersFormOrganization(this.organization.id).subscribe(res => {
            this.users = res.data.map(member => member.user).filter(user => !!user) as User[];
          });
          this.form = this.createPluginForm(this.organization, false);
          this.setupDeveloperModeListeners();
        });
      } else {
        // si no hay params, seteo la org desde el user
        this.cache.getUser().subscribe(user => {
          if (user.organization) {
            this.organization = user.organization;
            this.api.getMembersFormOrganization(this.organization.id).subscribe(res => {
              this.users = res.data.map(member => member.user).filter(user => !!user) as User[];
            });
          }
          this.form = this.createPluginForm(this.organization, true);
          this.setupDeveloperModeListeners();
        });
      }
    });
  }

  setupDeveloperModeListeners() {
    const devMode = this.form.get('developerMode.enabled');
    const docAiDevMode = this.form.get('developerMode.docAiDeveloperMode');
    const fieldRefInfo = this.form.get('developerMode.fieldReferenceInfo');

    if (devMode && docAiDevMode && fieldRefInfo) {
      if (!devMode.value) {
        docAiDevMode.disable({ emitEvent: false });
        fieldRefInfo.disable({ emitEvent: false });
      }

      devMode.valueChanges.subscribe(enabled => {
        if (enabled) {
          docAiDevMode.enable({ emitEvent: false });
          fieldRefInfo.enable({ emitEvent: false });
        } else {
          docAiDevMode.disable({ emitEvent: false });
          fieldRefInfo.disable({ emitEvent: false });
        }
      });
    }
  }


  createPluginForm(data: OrganizationExtended, disabled: boolean) {
    const devModeData = data.integrations?.developerMode;
    const form = this.fb.group({
      cargox: this.fb.group({
        available: [data.integrations?.cargox?.available || false],
        enabled: [data.integrations?.cargox?.enabled],
      }),
      iaDataExtraction: this.fb.group({
        enabled: [data.integrations?.iaDataExtraction?.enabled],
      }),
      splitDocuments: this.fb.group({
        enabled: [data.integrations?.splitDocuments?.enabled],
      }),
      edocs: this.fb.group({
        enabled: [data.integrations?.edocs?.enabled],
      }),
      powerBi: this.fb.group({
        enabled: [data.integrations?.powerBi?.enabled],
        url: [data.integrations?.powerBi?.url || '', [CustomValidators.validateDomain]],
      }),
      lune: this.fb.group({
        enabled: [data.integrations?.lune?.enabled],
      }),
      adam: this.fb.group({
        enabled: [data.integrations?.adam?.enabled],
      }),
      gesinflot: this.fb.group({
        enabled: [data.integrations?.gesinflot?.enabled],
        url: [data.integrations?.gesinflot?.url || ''],
        password: [data.integrations?.gesinflot?.password || ''],
        user: [data.integrations?.gesinflot?.user || ''],
      }),
      transportControl: this.fb.group({
        enabled: [data.integrations?.transportControl?.enabled],
      }),
      developerMode: this.fb.group({
        enabled: [devModeData?.enabled || false],
        docAiDeveloperMode: [devModeData?.docAiDeveloperMode || null],
        fieldReferenceInfo: [devModeData?.fieldReferenceInfo || null],
      }),
    });

    if (disabled) form.disable();

    return form;
  }

  save() {
    const data: { integrations: IntegrationsData } = { integrations: this.form.getRawValue() };

    this.api.editOrganizationData(data, this.organization.id).subscribe((res) => {
      this.api.log('toast.saved');
      this.organization = res;
    });
  }
}
